import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MailCheck, Loader2 } from "lucide-react";
import { adminGetSettings, adminSaveSettings, formatApiErrorDetail } from "@/api";

export default function SettingsTab() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminGetSettings()
      .then((s) => setEmail(s.notify_email))
      .catch(() => toast.error("Could not load settings"))
      .finally(() => setLoading(false));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await adminSaveSettings({ notify_email: email });
      setEmail(res.notify_email);
      toast.success("Notification email saved");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="settings-tab" className="max-w-xl">
      <form onSubmit={save} className="bg-[#122659] border border-sky-300/20 rounded-xl p-8 space-y-5">
        <div className="flex items-center gap-3 mb-2">
          <MailCheck size={24} className="text-[#F57C00]" />
          <h2 className="font-display text-xl font-black text-white">Lead notifications</h2>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">
          Every new application, pre-qualification and enquiry is emailed to this
          address. Use an inbox that already receives mail (e.g. Gmail or
          Outlook) — brand-new domains without a mailbox can't receive email yet.
        </p>
        <div>
          <label className="input-label" htmlFor="set-notify">Notification email</label>
          <input
            id="set-notify"
            data-testid="settings-notify-email"
            type="email"
            required
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@gmail.com"
            disabled={loading}
          />
        </div>
        <button
          type="submit"
          data-testid="settings-save-btn"
          disabled={saving || loading}
          className="bg-[#F57C00] hover:bg-[#E67300] disabled:opacity-60 text-white font-bold px-6 py-3.5 rounded-md transition-colors duration-300 flex items-center gap-2"
        >
          {saving && <Loader2 size={16} className="animate-spin" />}
          {saving ? "Saving…" : "Save settings"}
        </button>
      </form>
    </div>
  );
}
